
@switch ((data$ | async)?.uid) {
  @case ('NoticeTextParagraphComponent') {
    <app-footer-notice [data]="data$"></app-footer-notice>
  }
  @case ('NoProductFoundParagraphComponent') {
    <app-no-products-found [data]="data$"></app-no-products-found>
  }
  @case ('UploadViewParagraphComponent') {
    <app-bulkorder-upload-paragraph [data]="data$"></app-bulkorder-upload-paragraph>
  }
  @case ('UploadViewNoteParagraphComponent') {
    <app-bulkorder-upload-type-paragraph [data]="data$"></app-bulkorder-upload-type-paragraph>
  }
  @case ('DownloadViewParagraphComponent') {
    <app-bulkorder-download-paragraph [data]="data$"></app-bulkorder-download-paragraph>
  }
  @case ('SubmitViewProductFoundNoteParagraphComponent') {
    <app-bulkorder-product-found-paragraph [data]="data$"></app-bulkorder-product-found-paragraph>
  }
  @case ('SubmitViewProductNotFoundNoteParagraphComponent') {
    <app-bulkorder-product-notfound-paragraph [data]="data$"></app-bulkorder-product-notfound-paragraph>
  }
  @case ('UserProfileInternalRoleParagraphComponent') {
    <app-profile-paragraph [data]="data$"></app-profile-paragraph>
  }
  @case ('UserProfileExternalRoleParagraphComponent') {
    <app-profile-paragraph [data]="data$"></app-profile-paragraph>
  }
  @case ('EmptyOrderRequestsParagraphComponent') {
    <app-no-request-found [data]="data$"></app-no-request-found>
  }
  @default {
    <div [innerHTML]="sanitizer.bypassSecurityTrustHtml((data$ | async)?.content)" class="anonymous-user-container"></div>
  }
}
